import * as Contentful from 'contentful';
import { SessionStorage } from 'src/utils/SessionStorage';

const CONTENTFUL_CUSTOM_KEY = 'customContentfulKey';

export interface IContentfulClientConfig extends Contentful.CreateClientParams {
  isCustom?: boolean;
  isPreview?: boolean;
}

export class ContentfulClientConfig implements Contentful.CreateClientParams {
  // Contentful.CreateClientParams fields
  space: string;
  accessToken: string;
  environment?: string;
  insecure?: boolean;
  basePath?: string;
  httpAgent?: any;
  httpsAgent?: any;
  proxy?: Contentful.AxiosProxyConfig;
  headers?: any;
  host?: string;
  application?: string;
  integration?: string;
  resolveLinks?: boolean;
  removeUnresolved?: boolean;
  retryOnError?: boolean;
  logHandler?: ((level: Contentful.ClientLogLevel, data?: any) => void);
  timeout?: number;

  // Custom fields
  isCustom: boolean;
  isPreview: boolean;

  static create(params: IContentfulClientConfig) {
    let config = new ContentfulClientConfig(params);
    // Bookmarklet can set a custom key to use
    const customContentfulKeyItem = SessionStorage.tryGetItem(CONTENTFUL_CUSTOM_KEY);

    if (customContentfulKeyItem) {
      const customContentfulKey: { isPreview: boolean; accessToken: string } = JSON.parse(customContentfulKeyItem);

      config = {
        ...config, ...customContentfulKey,
        isCustom: true,
      };
    }

    // return a shallow-copy to make sure fields that are set are enumerable
    return { ...config };
  }

  private constructor(config: IContentfulClientConfig) {
    const { host, isPreview, ...values } = config;

    // set this instance
    Object.assign(
      this,
      // defaults for custom config
      {
        isCustom: false,
        isPreview,
        host: isPreview ? 'preview.contentful.com' : host,
      },
      // overrides
      values
    );
  }
}
